/**
 * The list search box's settings (KPR-740, epic KPE-029).
 *
 * THE GATE (owner ruling t05, KPE-029). A search reads every searched field of
 * every item of the list, with no index (KPR-738 section 3), so on a very large
 * list it must meet the speed bar before people are handed a box that can be
 * slow. KPR-748 built the fix (count and page together, one planner shape) and
 * left the live timing on Vehicle models to the owner. Until that timing meets
 * the bar (every warm run under 500 ms, the first under 1 s), the box is not
 * drawn on a list over `LIST_SEARCH_MAX_ITEMS` items.
 *
 * THE ONE SETTING. When the bar is met, set the constant to `null` and the gate
 * is gone: nothing else in the client asks how large a list is for this.
 */
export const LIST_SEARCH_MAX_ITEMS = 15000;

/**
 * Whether the search box may be drawn for a list of `size` items. A size that
 * is not known (still being counted, or the count failed) does not hide the
 * box: the gate protects the database from a slow read on a known-large list,
 * and an unknown list is not known to be one.
 *
 * `limit` is the setting; a test passes its own.
 */
export function listSearchAvailable(size, limit = LIST_SEARCH_MAX_ITEMS) {
	if (limit === null || limit === undefined || !Number.isFinite(limit)) return true;
	const n = Number(size);
	if (size === null || size === undefined || size === '' || !Number.isFinite(n)) return true;
	return n <= limit;
}
